import { CartActions, CLEAN_CART, SET_CART_SIZE } from './cart.actions';

export interface State {
  cartSize: number;
}

const initialState: State = {
  cartSize: 0
};

export function cartReducer(state = initialState, action: CartActions) {
  switch (action.type) {
    case SET_CART_SIZE:
      return {
        ...state,
        cartSize: action.payload
      };

    case CLEAN_CART:
      return {
        ...state,
        cartSize: 0
      };
    default: {
      return state;
    }
  }
}

export const getCartSize = (state: State) => state.cartSize;
